import { apiPostForm } from '@shared/api/apiClient';
import UrlUtilities from '@shared/common/UrlUtilities';

export interface AssetTagCsvImportResult {
    Success: boolean;
    ValidationFailed: boolean;
    FileName: string;
    SuccessfulRows: number | null;
    FailedRows: number | null;
    Message: string;
    DiagnosticId: string;
}

export function importAssetTagCsv(facilityId: string, assetClassId: string, file: File): Promise<AssetTagCsvImportResult> {
    const body = new FormData();
    body.append('facilityId', facilityId);
    body.append('assetClassId', assetClassId);
    body.append('file', file);
    return apiPostForm(`${UrlUtilities.getApiUrl()}/FacilityApi/api/Schema/AssetTags/ImportCsv`, body,
        { retryOnAuthFailure: false });
}
